/**
 * LOINC codes for breast cancer screening observations (LG41854-7)
 * Includes mammography (MG), digital breast tomosynthesis (DBT),
 * full-field digital (FFD), ultrasound (US), and X-ray (XR) screening only.
 * Excludes diagnostic, guidance, biopsy, aspiration, and other procedural codes.
 */
export const BREAST_CANCER_SCREENING_LOINC_CODES = [
  "24606-6", // MG Breast Screening
  "26175-0", // MG Breast - bilateral Screening
  "26176-8", // MG Breast - left Screening
  "26177-6", // MG Breast - right Screening
  "39153-2", // FFD mammogram Breast Screening
  "42132-1", // US Breast screening
  "42174-3", // FFD mammogram Breast - bilateral Screening
  "46354-7", // FFD mammogram Breast - right Screening
  "46355-4", // FFD mammogram Breast - left Screening
  "46356-2", // MG Breast - unilateral Screening
  "48492-3", // MG Breast - bilateral Screening for implant
  "69159-2", // XR Breast Screening for implant
  "72140-7", // DBT Breast - right screening
  "72141-5", // DBT Breast - left screening
  "72142-3", // DBT Breast - bilateral screening
  "91520-7", // DBT Breast - right screen for implant
  "91521-5", // DBT Breast - left screen for implant
  "91522-3", // DBT Breast - bilateral screen for implant
  "103885-0", // MG Breast - left Screening for implant
  "103886-8", // MG Breast - right Screening for implant
  "103892-6", // DBT Breast screening
  "103893-4", // MG Breast Screening for implant
  "105420-4", // US Breast - left screening
  "105421-2", // US Breast - right screening
  "105422-0", // US Breast - bilateral screening
];

/**
 * SNOMED CT codes for breast cancer screening procedures
 * Excludes: diagnostic, biopsy, findings, disorders, situations, and physical objects
 */
export const BREAST_CANCER_SCREENING_SNOMED_CODES = [
  "24623002", // Screening mammography (procedure)
  "384151000119104", // Screening mammography of bilateral breasts (procedure)
  "392521000119107", // Screening mammography of right breast (procedure)
  "392531000119105", // Screening mammography of left breast (procedure)
  "711151000124100", // Referral for screening mammogram for malignant neoplasm of breast (procedure)
];

/**
 * CPT codes for breast cancer screening
 * Excludes: diagnostic mammography, biopsy, localization, CAD add-ons, quality measure
 * codes (3xxxF / 7xxxF), and non-standard/local codes.
 * Note: 76092 and 77057 are deleted codes but were historically valid screening codes
 * and may appear in legacy data.
 */
export const BREAST_CANCER_SCREENING_CPT_CODES = [
  "76092", // Mammography screening, bilateral (deleted; legacy data)
  "77052", // CAD, screening mammography add-on (deleted 2017; legacy data)
  "77057", // Mammography, screening, bilateral (deleted; replaced by 77067)
  "77063", // Screening digital breast tomosynthesis, bilateral (add-on)
  "77067", // Screening mammography, bilateral (2-view), including CAD when performed
  "G0202", // Screening mammography, digital, bilateral (Medicare)
];
